import * as net from '../net';

const EdiDAO = {};

EdiDAO.get_edi_file = (id) => net.get({url: `/api/edi-files/${id}`});

EdiDAO.get_edi_files = () => net.get({url: '/api/edi-files'});

export default EdiDAO;
